import React from "react";
import {withNamespaces} from "react-i18next";
import HilightDeviceBox from "../../../../components/HilightDeviceBox";

const NetworkDeviceBox = ({list, selectedDeviceType, selectedStatusValue, t}) => {
    // default list
    let resultList = list;

    // filter activate
    if(selectedDeviceType !== 0) {
        resultList = list?.filter((item) => item.deviceTypeId === selectedDeviceType);
    }

    if(typeof selectedStatusValue === "boolean") {
        resultList = resultList?.filter((item) => item.isOnline === selectedStatusValue && item.isOnlineNetwork === selectedStatusValue);
    }

    if(selectedStatusValue === "warning") {
        resultList = resultList?.filter((item) => (item.isOnline === false && item.isOnlineNetwork === true) || (item.isOnline === true && item.isOnlineNetwork === false));
    }

    const items = resultList?.map((item) => {
        return (
          <HilightDeviceBox key={item.id} item={item}/>
        )
    });

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { items ? (
                <div className="row">
                    {items}
                </div>
            ) : (
                <div className="text-center p-4">
                    <h3>{ t('network-device-no-content')  }</h3>
                </div>
            ) }
        </div>
    )
};
export default withNamespaces()(NetworkDeviceBox);
